const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'master',
		'master'
	],

	methods: {
		refreshAll(){
			$('body > .appContainer > .status > div:not(.templates_nav_controller), body > .appContainer > .top > div, .base_tabStrip_tabStrip.nav, .templates_nav_nav').each((i, element) => {
				const c = getComponent(element, true)
				if(c){
					c.refresh()
				}
			})
		}
	},

	handlers: [
		{
			name: 'onLangCodeUpdate',
			async handle(){
				this.refreshAll()
			}
		},
		{
			name: 'onSuccessfulLoginDialog',
			async handle(){
				this.refreshAll()
			}
		},
		{
			name: 'onDocumentVisibilityChanged',
			handle: function(callerComponent, documentHidden){
				utils.keyboard.resetKeysActive()
			}
		},
	],
}